import {
    FETCH_PAYMENTS_REPORT,
    INVOICE_SENT
} from '../types';
import api from '../api';

export const fetchPaymentsReport = (data) => {
    return {
        type: FETCH_PAYMENTS_REPORT,
        payload: api.reports.payments(data),
    };
};

export const sendInvoice = (data) => {
    return {
        type: INVOICE_SENT,
        payload: api.invoices.send(data),
        meta: { toastSuccess: true }
    };
};
